import { format } from 'date-fns';
import { BookingConfig } from '../../BookingConfiguration/types';

type CalendarAvailabilityConfig = {
  days?: BookingConfig['days'];
  excluded_days?: BookingConfig['excluded_days'];
};

const DEFAULT_WORKING_DAYS = [1, 2, 3, 4, 5];

const getIsoDay = (date: Date) => {
  const day = date.getDay();
  return day === 0 ? 7 : day;
};

/**
 * Whether a date is a working day per SMB config (recurring working days minus
 * specific excluded/holiday dates). Drives the red non-working-day columns —
 * this stays config-driven; availability itself comes from the backend.
 */
export const isWorkingDayForConfig = (
  config: CalendarAvailabilityConfig | null | undefined,
  date: Date,
) => {
  const workingDays = config?.days || DEFAULT_WORKING_DAYS;
  const isoDay = getIsoDay(date);

  if (!workingDays.includes(isoDay)) return false;

  const dateStr = format(date, 'yyyy-MM-dd');
  const excludedDays = config?.excluded_days?.days?.map((entry) => entry.day) || [];
  return !excludedDays.includes(dateStr);
};

/**
 * Build a [start, end) range from a date + HH:mm start/end strings.
 * If end <= start the slot crosses midnight, so end rolls to the next day
 * (overnight slot support).
 */
export const buildSlotRangeFromDateAndTimes = (
  selectedDate: string,
  startTime: string,
  endTime: string,
) => {
  const start = new Date(`${selectedDate}T${startTime}:00`);
  const end = new Date(`${selectedDate}T${endTime}:00`);

  if (end <= start) {
    end.setDate(end.getDate() + 1);
  }

  return { start, end };
};
